module.exports = __webpack_public_path__ + "assets/widget-27862b7a.png";